import { AfterViewInit, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { take, takeWhile } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

import { ProductService } from '../../services/product.service';
import { OrderService } from '../../services/order.service';
import { Product } from '../../models/product.model';

import {hidePreloader} from '../../shared/utils';
import { ToastrService } from 'ngx-toastr';
import { GoogleAnalytics } from '../../services/google-analytics.service';
import {Order} from '../../models/order.model';
import {OrderItem} from '../../models/order-item.model';
import {OrderWindow} from '../../models/order-window.model';
import {AuthService} from '../../services/auth.service';
import {ModalService} from '../../services/modal.service';
import {MobileCheckServiceService} from '../../services/mobile-check-service.service';
import {MultiTenantService} from '../../services/multi-tenant.service';

@Component({
    selector: 'app-product',
    templateUrl: './product.component.html',
    styleUrls: ['./product.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ProductComponent implements OnInit, OnDestroy, AfterViewInit {

    @BlockUI() blockUI: NgBlockUI;

    public product: Product;
    public activeOrder: Order;
    public activeOrderWindow: OrderWindow;
    public orderType: string;
    private alive = true;
    private routeParams: object;
    public heroSlides: Array<object>;
    public products: Array<Product> = [];
    private programSlug: string;
    private programId: number;
    private productId: number;
    public arrayOfImages: Array<object>;
    public relatedPids: number[];

    public changedOrderItem: OrderItem = null;
    private isBuyingWindow = false;

    constructor(
        protected productService: ProductService,
        protected orderService: OrderService,
        private authService: AuthService,
        private modalService: ModalService,
        private route: ActivatedRoute,
        private router: Router,
        private toastr: ToastrService,
        private googleAnalytics: GoogleAnalytics,
        private mobileCheckService: MobileCheckServiceService,
        private multiTenantService: MultiTenantService
    ) {
        if (this.route.snapshot.params['program-slug']) {
            this.programSlug = this.route.snapshot.params['program-slug'];
        }
    }

    ngOnInit() {

        // tmp -
        window['productDetails'] = this;

        this.routeParams = this.route.snapshot.params;
        this.orderType = this.route.snapshot.data.orderType;

        this.isBuyingWindow = this.router.url.indexOf('buying-window') !== -1;
        const windowId: number = this.routeParams['buying-window-id']
            ? +this.routeParams['buying-window-id'] : null;
        if (!windowId) {
           // product component show OD product as well
           // this.initData()
        } else {

            this.orderService.getActiveOrderWindow().pipe(
                takeWhile(() => this.alive),
            ).subscribe( orderWindow => {
                if (orderWindow) {
                    this.activeOrderWindow = orderWindow;
                    if (windowId && orderWindow.id !== windowId) {
                        // switch to window id from url
                        this.orderService.switchActiveOrderWindowById(windowId);
                        // wait until initialization
                        this.orderService.isInitialized().pipe( takeWhile( () => this.alive)).subscribe(
                            result => {
                                if (result) {
                                    // this.initData();
                                }
                            }
                        )
                    } else {
                        // this.initData();
                    }

                }
            });
        }

        this.initOrder();

    }

    private initData() {

        const wslrEntityId = this.activeOrder.isWSLR ? this.activeOrder.entity_id : 0;
        this.productService.getProduct(this.routeParams['product-slug'], wslrEntityId, false, true)
            .subscribe(data => {
                this.product = data;

                if (!this.product) {
                    return;
                }
                this.googleAnalytics.viewItem(this.product);
                const arr_length = this.product.attrs.length;

                if (this.product.window_id > 0 ) {
                    // for BW product - check order window id is correct
                    if (this.product.window_id !== this.orderService.activeOrderWindowID) {
                        this.toastr.warning(this.multiTenantService.productWrongWindowLabel);
                        this.router.navigate(['/']);
                    }
                }

                // search through product attributes to find attribute for related PIDs
                function search(nameKey, searchArray) {
                    for (let i = 0; i < arr_length; i++) {
                        if (searchArray[i].attr === nameKey) {
                            return searchArray[i];
                        }
                    }
                }

                const related_ids = search('related_items', this.product.attrs);
                if (related_ids) {
                    this.relatedPids = related_ids.value.split(',').map( val => +val);
                }
                if (this.relatedPids) {
                    this.productService.getProductsByIds(this.relatedPids)
                        .pipe(take(1))
                        .subscribe(productsData => {
                            this.products = productsData;
                            this.blockUI.stop();
                        });
                }

                // Refetch aggregated quantity
                if (this.orderService.activeOrderWindowID) {
                    this.productService.refreshAggregateQuantities([this.product], this.orderService.activeOrderWindowID)
                        .pipe(take(1))
                        .subscribe((products) => {

                            if (Array.isArray(products) && products.length === 1) {
                                this.product = products[0];
                            }
                        });
                }

                if (this.product.product_group_id > 0) {
                    this.productService.getCatalog(this.product.product_group_id)
                        .pipe(takeWhile(() => this.alive))
                        .subscribe(catalogData => {
                            const media: any = catalogData.getHeroImage();

                            if (media) {
                                this.heroSlides = [{
                                    image: media.url,
                                    headline: '',
                                    description: '',
                                    url: catalogData.programDetailsUrl,
                                }];
                            }
                        });
                }
                this.blockUI.stop();
            });
    }

    private initOrder() {
        const type = this.isBuyingWindow ? 'activeBWOrder' : 'activeODOrder';
        this.orderService.toRx(type).pipe(takeWhile(() => this.alive)).subscribe(data => {
            if (data && data.loaded) {
                if (!this.activeOrder || !this.activeOrder.isTheSame(data)) {
                    this.activeOrder = new Order(data);
                    this.initData();
                } else {
                    this.activeOrder = new Order(data);
                }
            }
        });
    }


    ngAfterViewInit() {
        hidePreloader();
    }

    ngOnDestroy() {
        this.alive = false;
    }

    onOrderItemChanged(orderItem: OrderItem) {
        this.changedOrderItem = orderItem;
    }

    get canShowOrderSettings(): boolean {
        if (!this.authService.canEditOrderSettings(this.activeOrder)) {
            return false;
        }

        if (this.isBuyingWindow) {
            if (!this.activeOrderWindow || !this.activeOrderWindow.active) {
                return false;
            }
        }

        return true;
    }

    public editOrderSettings() {
        this.modalService.editOrderSettings(this.activeOrder).then( retOrder => {
            if (retOrder) {
                this.activeOrder = retOrder;
            }
        });
    }

    get mobile(): boolean {
        return this.mobileCheckService.mobile;
    }

    get mobileDevice(): boolean {
        return this.mobileCheckService.mobileDevice;
    }

    get tabletDevice(): boolean {
        return this.mobileCheckService.tabletDevice;
    }

    get isItemCut(): boolean {
        return this.product?.item_cut ? this.product.item_cut : false;
    }
}
